<div class="container-fluid py-4">
  <div class="row">

    <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
      <div class="card">
        <div class="card-header">
          <div class="text-end pt-1">
            <p class="text-sm mb-0 text-capitalize">Montant Payé</p>
            <h4 class="mb-0">
              {{ (dashboradPaiement?.paidAmounts ?? 0) | dashboradPaiement }} DT
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
      <div class="card">
        <div class="card-header">
          <div class="text-end pt-1">
            <p class="text-sm mb-0 text-capitalize">Montant Consultation</p>
            <h4 class="mb-0">
              {{ (dashboradPaiement?.regularConsultationAmounts ?? 0) | dashboradPaiement }} DT
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 mb-xl-0">
      <div class="card">
        <div class="card-header">
          <div class="text-end pt-1">
            <p class="text-sm mb-0 text-capitalize">Montant Actes</p>
            <h4 class="mb-0">
              {{ (dashboradPaiement?.regularConsultationEntriesAmounts ?? 0) | dashboradPaiement }} DT
            </h4>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-3 col-sm-6 mb-xl-0 mb-4">
      <div class="card">
        <div class="card-header">
          <div class="text-end pt-1">
            <p class="text-sm mb-0 text-capitalize">Balance</p>
           <h4 class="mb-0">
  {{
    (
      (dashboradPaiement?.regularConsultationAmounts ?? 0)
      + (dashboradPaiement?.regularConsultationEntriesAmounts ?? 0)
      - (dashboradPaiement?.paidAmounts ?? 0)
    ) < 0 ? '+' :
    (
      (dashboradPaiement?.regularConsultationAmounts ?? 0)
      + (dashboradPaiement?.regularConsultationEntriesAmounts ?? 0)
      - (dashboradPaiement?.paidAmounts ?? 0)
    ) > 0 ? '-' : ''
  }}{{
 
    (
      (dashboradPaiement?.regularConsultationAmounts ?? 0)
      + (dashboradPaiement?.regularConsultationEntriesAmounts ?? 0)
      - (dashboradPaiement?.paidAmounts ?? 0) | abs
    )
  }} DT
</h4>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
